import {Controller} from "@hotwired/stimulus";

const HIDDEN_CLASS = "page-menu--hidden";

export default class extends Controller {
    // workaround to type readonly element
    // this will return the element that was detected as controller
    get el(): HTMLElement {
        return this.element as HTMLElement;
    }

    close() {
        this.el.classList.add(HIDDEN_CLASS);
    }

    toggle() {
        this.el.classList.toggle(HIDDEN_CLASS)
    }
}
